import type { WeeklyScheduleState } from '@/sections/attacks/capabilities/components/WeeklySchedule';

/**
 * Helper function to create default weekly schedule state
 *
 * Extracted to separate file to avoid Fast Refresh violation
 * in WeeklySchedule component.
 */
export function createDefaultWeeklySchedule(): WeeklyScheduleState {
  return {
    monday: { enabled: false, time: '09:00' },
    tuesday: { enabled: false, time: '09:00' },
    wednesday: { enabled: false, time: '09:00' },
    thursday: { enabled: false, time: '09:00' },
    friday: { enabled: false, time: '09:00' },
    saturday: { enabled: false, time: '09:00' },
    sunday: { enabled: false, time: '09:00' },
  };
}
